import styled from 'styled-components/macro';

export const ScRecoveryText = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.whiteColor};
`;
